import type { PersonalizationType } from "../../types";
import type { BaseOptionListsType } from "./types";

const alwaysAvailableAttributes: PersonalizationType[] = [
  "BASIC_ATTRIBUTES",
  "CUSTOM_ATTRIBUTES",
  "CALCULATED_ATTRIBUTES",
  "NESTED_CUSTOM_ATTRIBUTES",
  "MOST_RECENT_DEVICE_ATTRIBUTES",
  "CONTENT_BLOCKS",
  "PREFERENCE_CENTER",
  "LANDING_PAGE",
];

export const baseOptionLists: BaseOptionListsType = {
  campaign: [
    ...alwaysAvailableAttributes,
    "CAMPAIGN_PROPERTIES",
    "API_TRIGGER_EVENT_PROPERTIES",
    // we allow the event specific-properties to be used in campaigns because events are chosen after composition
    "EVENT_PROPERTIES",
    "ADVANCED_EVENT_PROPERTIES",
    "SMS_PROPERTIES",
    "WHATS_APP_PROPERTIES",
    "DATA_OBJECTS",
  ],
  messageStep: [
    ...alwaysAvailableAttributes,
    "CAMPAIGN_PROPERTIES",
    "WORKFLOW_PROPERTIES",
    "CONTEXT_PROPERTIES",
    // TODO (DASHI-3034) We will no longer need SMS and WhatsApp properties in the
    //  default list for messageStep once this task is done.
    //  We will then be able to detect event triggering of message steps,
    //  once the MessagesContext supports them.
    "SMS_PROPERTIES",
    "WHATS_APP_PROPERTIES",
    "DATA_OBJECTS",
  ],
  // Note landingPage orchestration type is used for all landing pages as well as email subscription pages.
  landingPage: alwaysAvailableAttributes,
  anything: [...alwaysAvailableAttributes, "API_TRIGGER_EVENT_PROPERTIES"],
  all: [
    ...alwaysAvailableAttributes,
    "API_TRIGGER_EVENT_PROPERTIES",
    "CAMPAIGN_PROPERTIES",
    "WORKFLOW_PROPERTIES",
    "CONTEXT_PROPERTIES",
  ],
};
